<button
  #trigger
  aria-haspopup="dialog"
  class="sidebar-announcement-trigger"
  type="button"
  [attr.aria-controls]="'sidebar-announcement-' + announcement().featureKey"
  [attr.aria-expanded]="expanded()"
  [attr.aria-label]="resolvedTriggerLabel"
  [class.feedback-announcement-trigger]="feedback()"
  (click)="announcementPopover.show($event)"
  (mouseenter)="announcementPopover.show($event)">
  <i aria-hidden="true" class="pi pi-megaphone"></i>
</button>
<p-popover
  #announcementPopover
  appendTo="body"
  styleClass="is-caret-hidden sidebar-announcement-popover"
  (onHide)="onHide(announcementPopover)"
  (onShow)="onShow(announcementPopover)">
  <ng-template pTemplate="content">
    <section
      class="sidebar-announcement-content"
      role="dialog"
      [attr.aria-labelledby]="
        'sidebar-announcement-title-' + announcement().featureKey
      "
      [id]="'sidebar-announcement-' + announcement().featureKey">
      <h2 [id]="'sidebar-announcement-title-' + announcement().featureKey">
        {{ translate(announcement().sidebarTitle || announcement().title) }}
      </h2>
      <p>{{ translate(announcement().description) }}</p>
      @for (
        highlight of announcement().sidebarHighlights ?? [];
        track highlight.title
      ) {
        <div class="sidebar-announcement-highlight">
          <h3>{{ translate(highlight.title) }}</h3>
          <p>{{ translate(highlight.description) }}</p>
        </div>
      }
      @if (primaryLabel; as label) {
        <div class="sidebar-announcement-actions">
          <shared-button
            class="sidebar-announcement-cta"
            [isDisabled]="disabled()"
            [label]="label"
            [pt]="actionButtonPT"
            [type]="sharedButtonType.Secondary"
            (clickEvent)="cta.emit(announcementPopover)" />
        </div>
      }
    </section>
  </ng-template>
</p-popover>
